import type { FC } from "react";

import { pageUrl } from "../../../utils/urls";

import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectCurrentCourseId } from "store/selectors";
import { viewStateActions } from "store/slices/view";
import { trackEvent } from "utils/amplitude";
import { usePresentation } from "utils/presentation";
import { Link } from "utils/routing";

interface ReturnToDefaultTabButtonProps {
  color: PresentationBannerColorType;
}

export const ReturnToDefaultTabButton: FC<ReturnToDefaultTabButtonProps> = ({ color }) => {
  const dispatch = useAppDispatch();
  const { presentedPageId, unfeaturedTab } = usePresentation();
  const currentCourseId = useAppSelector(selectCurrentCourseId);
  const presentedPageURL = pageUrl(currentCourseId, presentedPageId);

  if (!unfeaturedTab) {
    return null;
  }

  const onClick = () => {
    trackEvent("Presentation - Return", { eventCategory: "Button press" });
    dispatch(viewStateActions.setShouldResetPageTab(true)); // Reset the page tab to the default tab
  };

  return (
    <PillButton as={Link} kind={`banner-${color}`} size="s" to={presentedPageURL} onClick={onClick}>
      {t("common.return")}
    </PillButton>
  );
};
